export default __webpack_public_path__ + "static/media/email-notif.aa5099a6.svg";